import React from 'react';
import EnvConstant from '../../constants/EnvConstant';
import Router from '../../libs/router';
import { SectionRule as Styled } from '../../styles/about';

/**
 * ルール
 */
interface Props {
  isSp: boolean;
}

class SectionRule extends React.PureComponent<Props> {
  public componentDidMount(): void {
    // ガイドラインからのリンクの場合スクロールさせる
    const hash = window.location.hash.replace('#', '');
    Router.scrollToHash(hash);
  }

  public render(): React.ReactNode {
    const { isSp } = this.props;
    const captionImgSrc = isSp
      ? `${EnvConstant.API_COMMON_PANE_URL}/img/lounge/caption_about_rule_s.png`
      : `${EnvConstant.API_COMMON_PANE_URL}/img/lounge/caption_about_rule_l.png`;

    return (
      <Styled id="rule">
        <nav>
          <a href="#attention" className="text-blue-400 underline text-sm">
            ↓注意事項
          </a>
          <a href="#policy" className="text-blue-400 underline text-sm">
            ↓運営方針
          </a>
        </nav>
        <h2>
          <img src={captionImgSrc} alt="看護師さんや看護学生さんにほっとしてもらうために、守っていただきたいルールがあります" />
        </h2>
        <dl>
          <dt>◆ルール1</dt>
          <dd>
            <p>投稿やコメントは</p>
            <ul>
              <li>わかりやすく</li>
              <li>親身に</li>
              <li>
                ていねいな言葉遣いで
                {isSp && <br />}
                （公序良俗に反する言葉は使わない）
              </li>
              <li>内容に責任を持って</li>
            </ul>
            <p>書いてください。</p>
          </dd>

          <dt>◆ルール2</dt>
          <dd>
            <p>質問をした人は、回答（コメント）に対してお礼と経過報告をしましょう。</p>
          </dd>

          <dt>◆ルール3</dt>
          <dd>
            <p>反対意見、批判的な意見は、事実に基づいた理由と合わせて発言しましょう。</p>
          </dd>

          <dt>◆ルール4</dt>
          <dd>
            <p>特定個人を非難、批判したり、個人情報を書き込んだりしないでください。</p>
          </dd>

          <dt>◆ルール5</dt>
          <dd>
            <p>
              【
              <a className="text-blue-400 underline text-sm" href={`${EnvConstant.PORTAL_WEB_URL}/policies/terms`}>
                利用規約
              </a>
              】をお読みいただき、規約に沿ったご利用をお願いします。
            </p>
          </dd>
        </dl>
      </Styled>
    );
  }
}

export default SectionRule;
